import Vue from 'vue';
import Vuex from 'vuex';

import core from './modules/core';
import supplier from './modules/supplier';
import buyer from './modules/buyer';

import { insights } from './middlewares';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    ...core,
    ...supplier,
    ...buyer,
  },
  plugins: [insights],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js